import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

import { OperationsCartePorteurSearch } from '@/models/operationssearch.model'

export default {
  data () {
    return {
      loading: false,
      operationsCarteSearch: new OperationsCartePorteurSearch(),
      immediateDebit: 0,
      echeance: this.$store.state.porteur.editedEcheance,
      paginatedListOperations: [],
      currentPage: this.$route.hash ? this.$route.hash.split('#')[1] : 1,
      totalItems: (this.$store.state.porteur && this.$store.state.porteur.listOperationsCarte) ? this.$store.state.porteur.listOperationsCarte.length : 0,
      pages: (this.$store.state.porteur && this.$store.state.porteur.listOperationsCarte) ? Math.ceil(this.$store.state.porteur.listOperationsCarte.length / 40) : 1
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  methods: {
    formatDate (date) {
      var moment = require('moment')
      return moment(date).format('DD/MM/YYYY')
    },
    putDatasInPaginatedList (beginIndex) {
      this.paginatedListOperations = []
      beginIndex = 40 * beginIndex
      let endIndex = parseInt(beginIndex) + 40
      if (this.$store.state.porteur.listOperationsCarte.length <= 40) {
        this.paginatedListOperations = this.$store.state.porteur.listOperationsCarte
      } else {
        if (endIndex > this.$store.state.porteur.listOperationsCarte.length) {
          endIndex = this.$store.state.porteur.listOperationsCarte.length
        }
        for (let index = beginIndex; index < endIndex; index++) {
          this.paginatedListOperations.push(this.$store.state.porteur.listOperationsCarte[index])
        }
      }
    },
    changeAvailablePage () {
      this.putDatasInPaginatedList(this.currentPage - 1)
    }
  },
  mounted () {
    this.$store.dispatch('porteur/selectListOperationsCarte', null)
    this.operationsCarteSearch.login = this.$store.state.user.user.login

    if (this.$store.state.porteur && this.$store.state.porteur.editedEcheance) {
      this.operationsCarteSearch.cardId = this.$store.state.porteur.editedEcheance.cardId
      this.operationsCarteSearch.periodeId = this.$store.state.porteur.editedEcheance.periodeId
    }

    this.loading = true
    this.$store.dispatch('porteur/getOperationsCartePorteur', this.operationsCarteSearch).then(
      response => {
        if (response.length && response[0].echeanceDebitCreditList) {
          this.immediateDebit = response[0].cumulDebits
          // Si on vient de la partie gestionnaire ou porteur, on a deja l'info de GestionnaireOperations
          if (this.$store.state.user.user.groupe.name.indexOf('Porteur') !== -1) {
            let listOperations = {}
            let echeanceDebitCreditPortgestList = {}
            listOperations.echeanceDebitCreditPortgestList = echeanceDebitCreditPortgestList
            listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList = response[0].echeanceDebitCreditList.echeanceDebitCreditList

            for (let index = 0; index < listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList.length; index++) {
              listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].debitEntreprise = listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].entrepriseDebit
              listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].creditEntreprise = listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].entrepriseCredit
              listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].debitPorteur = listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].titulaireDebit
              listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].creditPorteur = listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].titulaireCredit
              listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].debitTotal = listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].totalDebit
              listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].creditTotal = listOperations.echeanceDebitCreditPortgestList.echeanceDebitCreditPortgestList[index].totalCredit
            }
            this.$store.dispatch('entreprise/selectListOperations', listOperations)
          }
          this.$store.dispatch('porteur/selectListOperationsCarte', response)
        } else {
          this.$store.dispatch('entreprise/selectListOperations', null)
          this.$store.dispatch('porteur/selectListOperationsCarte', response)
        }
        this.loading = false
        this.putDatasInPaginatedList(0)
      },
      error => {
        this.errorMessage = error.response
        this.loading = false
      }
    )
  },
  beforeCreate () {
    var moment = require('moment')
    if (this.$store.state.porteur && this.$store.state.porteur.editedPeriode) {
      this.$store.state.filArianePage = 'Opérations du ' + moment(this.$store.state.porteur.editedPeriode.dateDebut).format('DD/MM/YYYY') + ' au ' + moment(this.$store.state.porteur.editedPeriode.dateFin).format('DD/MM/YYYY')
    }

    if (this.$store.state.user.user.groupe.name.indexOf('Porteur')) {
      this.$store.state.filArianeMiddlePage = 'Dépenses cartes'
      this.$store.state.filArianeMiddleRouterLink = 'porteur/depensescarte'
    } else {
      this.$store.state.filArianeMiddlePage = 'Dépenses Entreprise'
      this.$store.state.filArianeMiddleRouterLink = 'entreprise/gestionnairedepenses'
    }
  }
}
